import { render, staticRenderFns } from "./Tarjeta.vue?vue&type=template&id=049159c6&"
import script from "./Tarjeta.vue?vue&type=script&lang=js&"
export * from "./Tarjeta.vue?vue&type=script&lang=js&"
import style0 from "./Tarjeta.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports